import { useRef, useState, useEffect } from "react";

const ALLOWED_TYPES = ["image/png", "image/jpeg", "image/jpg"];

const ImageUploadCard = ({
  label,
  required,
  onFileSelect,
  error,
  initialPreview,
  maxSizeMB = 2, // Default to 2MB, can be overridden
}) => {
  const fileInputRef = useRef(null);
  const [preview, setPreview] = useState(null);
  const [localError, setError] = useState("");
  const [fileName, setFileName] = useState("");

  useEffect(() => {
    if (initialPreview) {
      // Check if initialPreview is a URL string (from server) or a File object
      if (typeof initialPreview === 'string' && (initialPreview.startsWith('http') || initialPreview.startsWith('/'))) {
        // It's a URL from server
        setPreview(initialPreview);
        setFileName(""); // edit mode → no file selected yet
      } else if (initialPreview instanceof File) {
        // It's a File object
        setPreview(URL.createObjectURL(initialPreview));
        setFileName(initialPreview.name);
      } else {
        // Try to treat as URL
        setPreview(initialPreview);
        setFileName("");
      }
    } else {
      setPreview(null);
      setFileName("");
    }
  }, [initialPreview]);

  // const handleFile = (file) => {
  //   if (!file) return;

  //   if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
  //     setError("File size should be less than 5MB");
  //     return;
  //   }

  //   if (!ALLOWED_TYPES.includes(file.type)) {
  //     setError("Only PNG, JPG, JPEG files are allowed");
  //     return;
  //   }

  //   setError("");
  //   setPreview(URL.createObjectURL(file));
  //   onFileSelect?.(file);
  // };

  const handleFile = (file) => {
    if (!file) return;

    const maxSizeBytes = maxSizeMB * 1024 * 1024;
    if (file.size > maxSizeBytes) {
      setError(`File size should be less than ${maxSizeMB}MB`);
      return;
    }

    if (!ALLOWED_TYPES.includes(file.type)) {
      setError("Only PNG, JPG, JPEG files are allowed");
      return;
    }

    setError("");
    setFileName(file.name); // ✅ store file name
    setPreview(URL.createObjectURL(file));
    onFileSelect?.(file);
  };

  // const handleInputChange = (e) => {
  //   handleFile(e.target.files[0]);
  // };

  const handleInputChange = (e) => {
    handleFile(e.target.files[0]);
    e.target.value = "";
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleFile(e.dataTransfer.files[0]);
  };

  return (
    <div>
      <label className="block text-sm font-medium mb-2">
        {label} {required && <span className="text-error">*</span>}
      </label>

      <div
        className={`border rounded-md p-4 ${error ? "image-upload-error" : ""}`}
      >
        <div
          className={`border-2 border-dashed border-blue-200 bg-blue-50 rounded-md h-[140px]
                      flex flex-col items-center justify-center text-center text-sm text-gray-500
                      cursor-pointer transition ${
                        error ? "border-2 border-dashed input-error" : ""
                      }`}
          onClick={() => fileInputRef.current.click()}
          onDragOver={(e) => e.preventDefault()}
          onDrop={handleDrop}
        >
          {preview ? (
            <img
              src={preview}
              alt="Preview"
              className="h-full object-contain rounded"
            />
          ) : (
            <>
              <p>Upload or drag and drop</p>
              <p className="text-xs mt-1">(Max {maxSizeMB}MB. Formats: png, jpg, jpeg)</p>
            </>
          )}
        </div>

        <button
          type="button"
          onClick={() => fileInputRef.current.click()}
          className="mt-3 w-full bg-primary text-white text-sm py-2 rounded-md"
        >
          Upload
        </button>

        <input
          ref={fileInputRef}
          type="file"
          accept="image/png,image/jpeg,image/jpg"
          className="hidden"
          onChange={handleInputChange}
        />
      </div>

      {/* Error */}
      <div className="min-h-[16px]">
        {(error || localError) && (
          <p className="text-xs text-red-500 mt-1">{error || localError}</p>
        )}
      </div>
    </div>
  );
};

export default ImageUploadCard;
